import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { AllocationSuggestionTable } from 'src/components/allocations/AllocationSuggestion';
import { AccordionHeader } from './AccordionHeader';
import useStyles from './billDetailsStyles';
import { DASH } from './billDetailsUtils';
import { UtilityRail } from './UtilityRail';

/** Per-property allocation: utilities on the rail, the suggested table for the selected one. */
export function PropertyAllocation(_ref) {
  let allocation = _ref.allocation,
    currency = _ref.currency,
    _ref$defaultExpanded = _ref.defaultExpanded,
    defaultExpanded = _ref$defaultExpanded === void 0 ? false : _ref$defaultExpanded,
    _ref$isEditing = _ref.isEditing,
    isEditing = _ref$isEditing === void 0 ? false : _ref$isEditing,
    onApprove = _ref.onApprove,
    onChangeSetting = _ref.onChangeSetting,
    onReview = _ref.onReview,
    onSelectTarget = _ref.onSelectTarget,
    propertyOptions = _ref.propertyOptions;
  const classes = useStyles();
  const _useState = useState(defaultExpanded),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  const _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    activeIndex = _useState4[0],
    setActiveIndex = _useState4[1];
  const utilities = allocation.utilities || [];
  const safeIndex = utilities.length ? Math.min(activeIndex, utilities.length - 1) : 0;
  const table = utilities[safeIndex];
  return /*#__PURE__*/React.createElement("div", {
    className: classes.accordion
  }, /*#__PURE__*/React.createElement(AccordionHeader, {
    isExpanded: isExpanded,
    onToggle: () => setIsExpanded(current => !current),
    title: allocation.address || DASH
  }), isExpanded ? /*#__PURE__*/React.createElement("div", {
    className: classes.accordionBody
  }, utilities.length > 0 ? /*#__PURE__*/React.createElement(UtilityRail, {
    activeIndex: safeIndex,
    onChange: setActiveIndex,
    showStatus: true,
    utilities: utilities
  }) : null, utilities.length === 0 ? /*#__PURE__*/React.createElement("div", {
    className: classes.emptyState
  }, "No utilities to allocate for this property.") : /*#__PURE__*/React.createElement(AllocationSuggestionTable, {
    approveHint: "Creates the allocation for this service and approves it once it is worked out.",
    currency: currency,
    isEditing: isEditing,
    onApprove: onApprove,
    onChangeSetting: patch => onChangeSetting(allocation.propertyIndex, table.serviceType, patch),
    onReview: onReview,
    onSelectProperty: propertyId => onSelectTarget(table.key, {
      propertyId,
      utilityId: ''
    }),
    onSelectUtility: utilityId => onSelectTarget(table.key, {
      utilityId
    }),
    propertyOptions: propertyOptions,
    setting: table.setting,
    table: table,
    utilityOptions: table.utilityOptions
  })) : null);
}